import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import Index from './Index';


const initialValues = {
};

const validationSchema = Yup.object({
});

const inputTypeCase = [
    {
        id: 0,
        type: "متن",
        title: ""
    }, {
        id: 1,
        type: "عدد",
        title: ""
    }, {
        id: 2,
        type: "تاریخ",
        title: ""
    }
]


const Create = () => {

    const { addData: addDataSetTemplate } = useEntityCrud('Template/SetTemplate')
    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness')
    const [businessList, setBusinessList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const { isEditMode, setIsEditMode } = (false)
    const [orgAddress, setOrgAddress] = useState({
        buisnessId: "",
        groupId: "",
        serviceId: ""
    })
    const [serviceList, setServiceList] = useState([]);
    const [inputTypeList, setInputTypeList] = useState([]);
    const [path, setPath] = useState([
        {
            id: 0,
            type: "",
            title: ""
        },
    ])
    const navigate = useNavigate();

    useEffect(() => {
        readDataBusiness().then(res => {
            setBusinessList(res.data.result)
        });
    }, [])

    useEffect(() => {
        setInputTypeList(inputTypeCase.map(item => ({ value: item.id, label: item.title })));
    }, [serviceList])


    const onSubmit = () => {
         
        const string = JSON.stringify(path);
        const postedData = {
            "fields": string,
            "serviceId": orgAddress.serviceId.value,
            "serviceTitle" :""
        };
        addDataSetTemplate(postedData).then(res => {
             
            if (res.status === 200) {
                if (res.data.status === false) {
                    res.data.errors.map(error => toast.error(error.message));
                }
                else {
                    navigate("/template");
                    toast.success('قالب با موفقیت در سیستم ثبت شد');
                }
            } else
                res.data.errors.map(error => toast.error(error.message));
        }) 
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSubmit,
        validationSchema: validationSchema
    });


    const handleBack = () => {
        navigate('/template', { replace: true });
    }

    return (
        <div className="card">

            <div className="card-header  d-flex justify-content-between">
                <h3 class="card-title">
                  {/*   <i className='fa fa-plus px-1'></i> */}
                    اضافه کردن  قالب </h3>
                <a className='backIconLink' onClick={handleBack}> <i className='fa fa-arrow-left'
                    title="بازگشت"> </i> </a>
            </div>

            <div className="card-body">
                <Form
                    formik={formik}
                    serviceList={serviceList}
                    inputTypeList={inputTypeCase}
                    path={path}
                    setPath={setPath}
                    isEditMode={false}
                    setServiceList={setServiceList}
                    groupList={groupList} setGroupList={setGroupList}
                    businessList={businessList} setBusinessList={setBusinessList}
                    orgAddress={orgAddress} setOrgAddress={setOrgAddress}
                />
            </div>
        </div>
    );
}

export default Create;


